import React from 'react'
import './sticky-footer.css'

const Footer = () => (
  <div id='footer'>
    <div className='page-prefooter'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-4 col-sm-6 col-xs-12 footer-block'>
            <h2>About</h2>
            <p>
              Blue Robot: <br className='visible-xs' />Twitter automation for
              non-techies{' '}
            </p>
          </div>
          <div className='col-md-4 col-md-offset-4 col-sm-6 col-xs-12 footer-block'>
            <h2>Contact Us</h2>
            <address>
              Twitter:{' '}
              <a
                href='http://twitter.com/Bluerobot_'
                rel='noopener noreferrer'
                target='_blank'
              >
                @BlueRobot_
              </a>{' '}
              <br />
              Phone: +44 870 495 2637 <br />
              Email:{' '}
              <a href='mailto:support@bluerobot.com'>support@bluerobot.com</a>
            </address>
          </div>
        </div>
      </div>
    </div>
    <div className='page-footer'>
      <div className='container'>
        <div className='row'>
          <div className='col-sm-12'>
            {new Date().getFullYear()} © Ad Dynamo International LTD.{' '}
            <br className='visible-xs' />All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  </div>
)

Footer.displayName = 'Footer'

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/index.js